import React from "react";

function HeroLending() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  DeFi Lending & Borrowing Platform Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock the power of decentralized finance with Xeer
                    Technology's cutting-edge DeFi lending and borrowing
                    platform. We provide seamless and secure access to financial
                    services that empower users to lend and borrow digital
                    assets without the need for intermediaries.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroLending;
